import { Novedad, RolPlataforma } from '../models/novedades.models';
import { NovedadesService } from '../services/novedades.service';

export abstract class RoleNovedadesPresenter {
  novedades: Novedad[] = [];

  protected constructor(protected readonly novedadesService: NovedadesService) {}

  protected actualizarNovedades(rol: RolPlataforma): void {
    this.novedadesService.getNovedadesPorRol(rol).subscribe((data) => {
      this.novedades = data;
    });
  }
}
